export default {
  /**
   * 是否在移动端下
   *
   * @returns {boolean} 是否
   */
  isUnderMobile() {
    // iPad 包含： Mobi
    return /Android|iPhone/i.test(navigator.userAgent)
  },
  /**
   * 是否在原生应用里面
   *
   * @returns {boolean} 是否
   */
  isUnderNative() {
    return window.messageHandler !== undefined
  },
  /**
   * 是否在安卓平台下
   *
   * @returns {boolean} 是否
   */
  isAndroid() {
    return /Android/i.test(navigator.userAgent)
  },
  /**
   * 获取菜单展开的结果
   *
   * @param {object} message Native消息
   * @returns {?object} 数据。格式 { expanded: true }
   */
  getMenuExpanded(message) {
    if (message !== undefined && message['command'] === 'menu_expanded') {
      return message['data']
    }

    return { expanded: true } // 默认值
  }
}
